import React,{useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel,FormControl,Select as MaterialSelect  ,Box ,TextField
  ,RadioGroup,Radio, Grid, Typography, FormLabel, FormControlLabel} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../../funciones/ClienteAxios";
import Modal from '../../Generales/ModalTam';
import Rating from '@material-ui/lab/Rating';
import moment from 'moment/moment';
import Relojes from './Relojes';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const NuevoEditarHorometro = ({modalAbierto,setModalAbierto,titulo,regisMaquinaria,funcionActuliza, registroH}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [radioTipo, setRadioTipo] = useState("1"); 
  const [nvActividad,guardarNvActividad]= useState({Orden:0,  inicio:0.0, fin:0.0});  
  const [fechasSeleccionadas, setFechasSeleccionadas] = useState({inicio: new Date(), final: new Date()});
  const [leyendaFecha, setLeyendaFecha] = useState("");
  const {Orden, inicio, fin}=nvActividad    

  React.useEffect(()=>{   
    if (registroH.length!==0) {
      guardarNvActividad({
        ...nvActividad, Orden:registroH.Id, inicio:registroH.Ini,
        fin:registroH.Fin,

      })    
      
      const auxF=(moment.parseZone(registroH.FCap ).local(true))
      //console.log(registroH,auxF);
      
      setFechasSeleccionadas({...fechasSeleccionadas,inicio:auxF})   
      setRadioTipo(`${registroH.Encendido}`)                
    }        
    
   
   
    return ()=> {
      source.cancel();
    }     
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

  useEffect(()=>{
    setLeyendaFecha(moment(fechasSeleccionadas.inicio).format("DD/MM/YYYY"))
  },[fechasSeleccionadas])

  const registrarNActividad=(auxFcap)=>{               
  
    //let NomUsu= localStorage.getItem('UsuarioNom');  
    const data = qs.stringify({
      Llave:Orden,
      Usuario:idusu,
      Maquinaria:regisMaquinaria.Id,
      Captura:auxFcap,
      Ini:inicio,
      Fin:fin,
      Status:1,            
      Encendido:radioTipo ==="1"? 1 : 0,
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/maquinaria/horometro/new-edit";
  
    function respuesta(aux) {
      if (aux.respuesta==1) 
      { //console.log(aux);
        let mensaje='Se registro correctamente.'
        if (Orden!==0) {
          mensaje='Se edito correctamente.'
        }
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza(regisMaquinaria.Id)
        setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChangeNum = e =>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {  
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };
 
  const onChangeRad=(e)=>{
    setRadioTipo(e.target.value)                    
  }
 
  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { setTipoAdvertencia("warning")    
      setMensaje(mensaje);
      setAviso(true)     
    }
    return respuesta
  }

   function valNumero(auxNumero,auxCampo) {
    let valida=false    
    if (typeof parseInt(auxNumero) === 'number') 
    {
      if (parseInt(auxNumero) ==0) 
      {
        valida=true
      }  
      else{
        if (parseInt(auxNumero) >0) 
        {  
          valida=true
        } 
      }
    }
    if (!valida) {
      setTipoAdvertencia("warning")
      let mensaje="Llenar campo "+auxCampo            
      setMensaje(mensaje);
      setAviso(true)  
    }
    return valida
  }

  
  const guardarDatos = () => 
  { const fecha = moment(fechasSeleccionadas.inicio).format("YYYY-MM-DD")
    if ( validaDatos(inicio, "Llenar campo de Inicio.") && valNumero(inicio, "Inicio") 
    //  &&   validaDatos(fin, "Llenar campo de Fin.") && valNumero(fin, "Fin") 
    )  
    { registrarNActividad(`${fecha}T00:00:00`)                                   
    }                                           
  };

  const radioCampos=()=>{          
    return(    
    <FormControl component="fieldset" size="small" style={{marginLeft:.5+'rem', width:"20rem" }}>          
      {/* <FormLabel size="small" >{`Tipo`}</FormLabel>         */}
      <RadioGroup  row aria-label="position"  defaultValue="top"
        name={`radioTipo`} value={radioTipo} onChange={onChangeRad} size="small"
      >                      
        <FormControlLabel value={"1"}  label={ "Encendido"} 
          control={<Radio color="primary"  />} />                                   
        <FormControlLabel value={"2"}  label={ "Apagado"} 
          control={<Radio color="primary"  />} />          
      </RadioGroup>                     
    </FormControl>   
    )
  
  }

  return ( 
  <Modal
    titulo={`${titulo} ${leyendaFecha}`} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} 
    setEspera={setEspera}  tamanio={"sm"} btnDesact={btnDesact}
  >
    <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:30+'rem'}} > 
      <Box>
        <Relojes fechasSeleccionadas={fechasSeleccionadas} setFechasSeleccionadas={setFechasSeleccionadas} tipo={1} />
      </Box>                                      
      <Box display="flex" flexDirection="column">     
        {radioCampos()}      
                
      </Box>    
      <Box display={"flex"} flexDirection={"column"}>        
        <FormControl component="fieldset" style={{width:20+'rem', marginBottom:"1rem"}}>    
          <TextField id="inicio-TextArea" name="inicio" //rows="5" cols="100"
            label="Inicio" style={{width: 20+"rem",borderRadius:3+'px'}} 
            variant='outlined' size='small'
            value={inicio} onChange={onChangeNum} />          
        </FormControl>
        <FormControl component="fieldset" style={{width:20+'rem'}}>    
          <TextField id="fin-TextArea" name="fin" //rows="5" cols="100"
            variant='outlined' size='small'
            label="Fin" style={{width: 20+"rem",borderRadius:3+'px'}} 
            value={fin} onChange={onChangeNum} />          
        </FormControl>
      </Box>

    </form>
  </Modal>
  );
}
 
export default NuevoEditarHorometro;